import { useTheme } from '@mui/material/styles';
import { SearchResult } from 'functions/src/types/firestore/Search';
import { SearchResultBase } from './SearchResultBase';
import { GameAnnouncementIcon } from 'src/components/game-announcements/GameAnnouncementIcon';
import { AnnouncementType } from 'functions/src/types/firestore/Game/Announcement';

export type AnnouncementSearchResultProps = SearchResult & {
  category: 'announcement';
};

export const AnnouncementSearchResult = ({
  announcement,
  title,
  description,
}: AnnouncementSearchResultProps) => {
  const theme = useTheme();
  return (
    <SearchResultBase
      href={`/game/${announcement.gameId}`}
      imageSx={{
        display: 'flex',
        flexGrow: 0,
        minWidth: 90,
        minHeight: 90,
        borderRadius: '4px',
      }}
      image={
        <GameAnnouncementIcon
          announcementType={announcement.type as AnnouncementType}
          typographyVariant={announcement.type === 'patch' ? 'h5' : 'h4'}
          sx={{ height: '50px', width: '50px', ml: 5, mt: 5 }}
        />
      }
      header={title}
      headerSx={{
        ...theme.lineClamp(1),
      }}
      description={description}
      category="announcement"
    />
  );
};
